import React, { useState, useEffect} from "react";
import Table from "../../../../../components/Table/table";
import { heading, tableData } from "../../../../../services/planusageTableData";

const initialState = {
  plan: false,
  plans_used: false,
  roaming_totals: false,
  average_totals: false,
  other_costs: false,
  contractual_cost: false,
};

function PlanUsageCard({ setState, setPopup, dataPlans, setDataPlanId }) {
  const [data, setData] = useState([...tableData]);
  const [btns, setBtns] = useState(initialState);
  const [active, setActive] = useState("service_name");
  const [orderType, setOrderType] = useState("asc");

  useEffect(() => {
    dataPlans && setData(transformResponse(dataPlans));
  }, [dataPlans]);

  const transformResponse = (response) => {
    if (!response) return [];
    return response.map((item, index) => ({
      id: item?.id,
      name: item?.name,
      plan_used: item.plan_used,
      roaming_totals: item.roaming_cost,
      overage_totals: item.overage_cost,
      other_costs: item.other_cost,
      contractual_cost: item.contractual_cost,
      actual_cost: item.actual_cost,
    }));
  };

  const handlePlanName = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "plan" && active]: false,
    });
    setActive("plan");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.name || "";
      const serviceB = b.name || "";
      if (orderType === "asc") {
        return serviceB.localeCompare(serviceA);
      } else {
        return serviceA.localeCompare(serviceB);
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handlePlansUsed = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "plans_used" && active]: false,
    });
    setActive("plans_used");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.plan_used || "";
      const serviceB = b.plan_used || "";
      if (orderType === "asc") {
        return serviceB.localeCompare(serviceA);
      } else {
        return serviceA.localeCompare(serviceB);
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleRoamingTotals = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "roaming_totals" && active]: false,
    });
    setActive("roaming_totals");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.roaming_totals || 0;
      const serviceB = b.roaming_totals || 0;
      if (orderType === "asc") {
        return serviceB - serviceA;
      } else {
        return serviceA - serviceB;
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleOverageTotals = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "contractual_cost" && active]: false,
    });
    setActive("contractual_cost");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.contractual_cost || 0;
      const serviceB = b.contractual_cost || 0;
      if (orderType === "asc") {
        return serviceB - serviceA;
      } else {
        return serviceA - serviceB;
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleOtherCosts = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "other_costs" && active]: false,
    });
    setActive("other_costs");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.other_costs || 0;
      const serviceB = b.other_costs || 0;
      if (orderType === "asc") {
        return serviceB - serviceA;
      } else {
        return serviceA - serviceB;
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleContractualCost = (orderType, set) => {
    setBtns({
      ...btns,
      type: true,
      [active !== "other_costs" && active]: false,
    });
    setActive("other_costs");
    const sort = [...data].sort((a, b) => {
      const serviceA = a.other_costs || 0;
      const serviceB = b.other_costs || 0;
      if (orderType === "asc") {
        return serviceB - serviceA;
      } else {
        return serviceA - serviceB;
      }
    });
    setData([...sort]);
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  return (
    <div className="grid grid-cols-1 justify-center">
      <div className="flex flex-col bg-[#363D50] pb-[16px] rounded-[32px] w-[100%]">
        <div className="flex flex-col p-[24px] pb-2">
          <div className="flex items-center gap-[16px]">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.4075 6.11682C17.762 6.82099 17.2444 7.71932 16.8999 8.66634H21.4113C21.9297 8.65388 22.3388 8.51779 22.6441 8.29498C22.9604 8.06414 23.2152 7.70411 23.3538 7.16657C23.6719 5.93285 22.8697 4.66634 21.3327 4.66634C20.2375 4.66634 19.2373 5.21158 18.4075 6.11682ZM15.1642 8.66634C14.7975 7.71423 14.2804 6.81631 13.6444 6.1139C12.8247 5.20854 11.8476 4.66634 10.7555 4.66634C9.21853 4.66634 8.41634 5.93285 8.73442 7.16657C8.87302 7.70411 9.12785 8.06414 9.44414 8.29498C9.74942 8.51779 10.1585 8.65388 10.6769 8.66634H15.1642ZM16.026 7.31046C16.3941 6.546 16.8643 5.82706 17.4246 5.21586C18.4281 4.1211 19.7612 3.33301 21.3327 3.33301C23.7957 3.33301 25.1667 5.47542 24.6449 7.49945C24.5315 7.93932 24.3549 8.33174 24.1187 8.66844C25.9044 8.73131 27.3327 10.1987 27.3327 11.9997V14.6663C27.3327 16.0332 26.51 17.2079 25.3327 17.7223V22.6663C25.3327 24.5073 23.8403 25.9997 21.9993 25.9997H9.99935C8.1584 25.9997 6.66602 24.5073 6.66602 22.6663V17.7223C5.48875 17.2079 4.66602 16.0332 4.66602 14.6663V11.9997C4.66602 10.1692 6.14154 8.68326 7.9681 8.66648C7.73259 8.33021 7.5565 7.93847 7.44331 7.49945C6.92147 5.47542 8.29254 3.33301 10.7555 3.33301C12.3302 3.33301 13.6416 4.12414 14.6328 5.21902C15.1866 5.83065 15.6528 6.54893 16.026 7.31046ZM10.6627 9.99967H7.99935C6.89478 9.99967 5.99935 10.8951 5.99935 11.9997V14.6663C5.99935 15.7709 6.89478 16.6663 7.99935 16.6663H15.3327V9.99967H10.7555V10.0006C10.7245 10.0006 10.6935 10.0003 10.6627 9.99967ZM21.3327 10.0006V9.99967H16.666V16.6663H23.9993C25.1039 16.6663 25.9993 15.7709 25.9993 14.6663V11.9997C25.9993 10.8951 25.1039 9.99967 23.9993 9.99967H21.4255C21.3947 10.0003 21.3637 10.0006 21.3327 10.0006ZM16.666 17.9997H23.9993V22.6663C23.9993 23.7709 23.1039 24.6663 21.9993 24.6663H16.666V17.9997ZM15.3327 17.9997V24.6663H9.99935C8.89478 24.6663 7.99935 23.7709 7.99935 22.6663V17.9997H15.3327Z"
                  fill="white"
                />
              </svg>
            </div>

            <div className="flex flex-start flex-col gap-[2px]">
              <div className="text-primary !text-[16px] !font-bold !leading-[24px]">
                Monthly plan usage ({dataPlans?.[0]?.billing_period_month})
              </div>
              <span className="text-secondary !text-[14px] !leading-[20px]">
                Key plan usage data for this service
              </span>
            </div>
          </div>
        </div>
        <div className="overflow-y-scroll scrollbar-hide max-h-[300px]">
          <Table
            headings={heading}
            tableData={data}
            setState={setState}
            setPopup={setPopup}
            setDataPlanId={setDataPlanId}
            table={"planUsage"}
            handlePlanName={handlePlanName}
            handlePlansUsed={handlePlansUsed}
            handleRoamingTotals={handleRoamingTotals}
            handleOverageTotals={handleOverageTotals}
            handleOtherCosts={handleOtherCosts}
            handleContractualCost={handleContractualCost}
            orderType={orderType}
          />
        </div>
      </div>
    </div>
  );
}

export default PlanUsageCard;
